import GroupingSelector from './GroupingSelector'
import messageResource from '../messageResource'
import {ReportGroupingLevel} from './constants'
import _ from 'underscore'

export default function LeavesGroupingSelector()
{
    this.constructor = LeavesGroupingSelector;
}

LeavesGroupingSelector.prototype = _.create(GroupingSelector.prototype, {
    init: function(selectorId, selectedValues, isUGREnabled, isTZGEnabled, changesCallback)
    {
        this.UGREnabled = isUGREnabled
        this.TZGEnabled = isTZGEnabled

        GroupingSelector.prototype.init.call(this, selectorId, 2, selectedValues, changesCallback);

        return this;
    },

    fillListSelector: function(listSelector, level)
    {
        if (level > 0)
        {
            listSelector.addItems([{
                text: messageResource.getMessage("report.form.dont_use_2nd_grouping_level"),
                value: ReportGroupingLevel.NONE
            }]);
            listSelector.addSeparator();
        }
        listSelector.addItems([
            {
                text: messageResource.getMessage("report.common.users"),
                value: ReportGroupingLevel.USER
            }
        ])

        if (this.UGREnabled)
        {
            listSelector.addItems([{
                text: messageResource.getEscapedMessage("common.User_Groups"),
                value: ReportGroupingLevel.USER_GROUP
            }]);
        }

        if (this.TZGEnabled)
        {
            listSelector.addItems([{
                text: messageResource.getEscapedMessage("common.Time_Zone_Groups"),
                value: ReportGroupingLevel.TIME_ZONE_GROUP
            }]);
        }

        listSelector.addSeparator()

        listSelector.addItems([{text: messageResource.getMessage("report.common.dates"), value: ReportGroupingLevel.DATE},
                                  {text: messageResource.getMessage("report.common.weeks"), value: ReportGroupingLevel.WEEK},
                                  {text: messageResource.getMessage("report.common.months"), value: ReportGroupingLevel.MONTH}]);
    },

    updateTree: function()
    {
        var secondShown = this.getListSelectorValue(1) !== ReportGroupingLevel.NONE;

        this.setRowClassName(1, secondShown ? "tree-row-A" : "tree-row-I");
    },

    validate: function()
    {
        if (!GroupingSelector.prototype.validate.call(this))
            return false;

        return this.verifyDateGroupingOrderFroTwoLevels();
    }
});



// WEBPACK FOOTER //
// ./web/js/reports/LeavesGroupingSelector.js